// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"46db270b","513":"67e35c83","703":"d3115c4e","787":"bd02a09f"}[chunkId] + ".chunk.js";
};